import { render } from "./ContentblockTickets.vue?vue&type=template&id=df7c058a&scoped=true&ts=true"
import script from "./ContentblockTickets.ts?vue&type=script&lang=ts"
export * from "./ContentblockTickets.ts?vue&type=script&lang=ts"

import "./ContentblockTickets.scss?vue&type=style&index=0&id=df7c058a&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df7c058a"]])

export default __exports__